import UserManagement from "@/modules/usman/components/UserManagement";
import UserManagementDetail from "@/modules/usman/components/UserManagementDetail";
import UserManagementForm from "@/modules/usman/components/UserManagementForm";

export default [
    {
        path: "/user-management",
        name: "UserManagement",
        component: UserManagement,
    },
    {
        path: "/user-detail",
        name: "UserManagementDetail",
        component: UserManagementDetail,
    },
    {
        path: "/user-form",
        name: "UserManagementForm",
        component: UserManagementForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/usman/router/usman.js